<template>
  <div class="root">
    <div v-if="countFirewalls" class="firewall-head">
      <button @click="hidden = !hidden" class="firewall-button">
        <img v-if="hidden" src="../../files/plus-icon.svg" alt="plus-icon" />
        <img v-else src="../../files/minus-icon.svg" alt="minus-icon" />
      </button>
      <p v-if="countFirewalls" class="firewall-head-title">Противопожарные стены ({{ countFirewalls }})</p>
    </div>

    <ul
      :class="[
        'firewall-list',
        {
          'firewall-list_hidden': hidden,
        },
      ]"
      v-if="firewalls && firewalls.length > 0"
    >
      <li class="firewall-list-item" v-for="(firewall, firewallIndex) in firewallsWithId" :key="firewall.id">
        <div class="firewall-item">
          <div class="firewall-item-icon-block">
            <div class="firewall-icon-wrapper">
              <img
                draggable="false"
                src="../../assets/icons/fire_walls.svg"
                :class="[
                  'firewall-icon-image',
                  {
                    'firewall-icon_disabled': firewall.exclude && parseInt(firewall.exclude) != 0,
                  },
                ]"
              />
              <!-- Иконка исключенного из расчета -->
              <img
                src="../../assets/icons/disabled-icon.svg"
                v-if="firewall.exclude && parseInt(firewall.exclude) != 0"
                class="firewall-exclude-icon"
              />
            </div>
          </div>

          <div class="submenu-piplenes">
            <span class="submenu-map-objects-text black">
              {{ firewall.name }}
            </span>
            <span class="submenu-map-objects-text"
              >Высота, м: <span class="black">{{ firewall.H }}</span>
            </span>
          </div>

          <!-- Контекстное меню -->
          <firewall-dropdown
            :handleDropdownClick="handleDropdownClick"
            :shiftY="shiftY"
            @onFullTurnOff="firewallTurnOff(firewall.id, firewallIndex)"
            @onEditClick="$emit('firewallEdit', { firewall, index: firewallIndex })"
            @onRemoveClick="handleFirewallDelete(firewall.id, firewallIndex)"
            :firewall="firewall"
          />
        </div>
      </li>
    </ul>
    <confirm-modal
      ref="firewallRemoveModal"
      id="firewallRemoveModal"
      title="Удалить"
      content="Вы действительно хотите удалить эту стену?"
      @onSubmitClick="
        firewallRemove($refs.firewallRemoveModal.index, $refs.firewallRemoveModal.firewallId);
        $bvModal.hide('firewallRemoveModal');
      "
    />
  </div>
</template>

<script>
import FirewallDropdown from "./components/FirewallDropdown";
import { handleInstallationDropdownClick } from "../../utils/utils";
import ConfirmModal from "../modals/ConfirmModal.vue";

export default {
  components: { FirewallDropdown, ConfirmModal },
  props: {
    firewalls: [],
    project: {},
    action: String,
    temp: Object, // используется для передачи в родительский компонент данных для редактировании
  },
  data() {
    return {
      hidden: false,
      shiftY: 0,
    };
  },

  computed: {
    firewallsWithId() {
      if (this.firewalls) {
        return this.firewalls.filter((firewall) => firewall.id);
      }
      return this.firewalls;
    },
    countFirewalls() {
      return (this.firewalls && this.firewalls.length) || 0;
    },
  },

  methods: {
    handleDropdownClick(event) {
      this.shiftY = handleInstallationDropdownClick(event, 180);
    },

    firewallTurnOff(id, index) {
      this.$http
        .post("risk/firewalls/exclude?proj_id=" + this.project.id + "&id=" + id)
        .then((response) => {
          this.$set(this.firewalls[index], "exclude", response.data);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },

    firewallAdd() {
      this.$emit("update:action", "firewall");
      this.$emit("update:temp", {});

      this.$bvToast.show("new-firewalls-toast");
    },

    handleFirewallDelete(id, index) {
      this.$refs.firewallRemoveModal.index = index;
      this.$refs.firewallRemoveModal.firewallId = id;

      this.$bvModal.show("firewallRemoveModal");
    },

    firewallRemove(index, id) {
      this.$http
        .post("risk/firewalls/firewall-delete?proj_id=" + this.project.id + "&id=" + id)
        .then(() => {
          this.firewalls.splice(index, 1);
          this.$emit("clearCalculations")
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style scoped>
.root {
  margin-top: 16px;
}
.firewall-head {
  display: flex;
  align-items: center;
  gap: 4px;
}
.firewall-button {
  border: none;
  padding: 0;
  background: transparent;
}
.firewall-list-item {
  position: relative;
  margin-bottom: 8px;
}
.firewall-head-title {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--black-color);
  margin: 0;
}
.firewall-item-icon-block {
  position: relative;
  z-index: 1;
}
.firewall-icon-wrapper {
  position: relative;
  width: max-content;
}
.firewall-icon-image {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: cover;
}
.firewall-exclude-icon {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.firewall-badge {
  min-width: 35px;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: -2px;
  padding: 0px 4px;
  border-radius: 20px;
  background: var(--additional-color);
  pointer-events: none;
}
.firewall-badge-text {
  margin: 0;
  color: var(--white-color);
  font-size: 6px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
}
.firewall-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
.firewall-item-error-button {
  background: transparent;
  border: none;
}
.firewall-item-name {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  font-size: 12px;
  color: var(--black-color);
  margin: 0;
  flex-grow: 1;
  display: flex;
}
.firewall-list {
  margin-top: 8px;
  padding-left: 8px;
  max-height: 100%;
  overflow: auto;
}

.firewall-list_hidden {
  max-height: 0;
  overflow: hidden;
}

.submenu-map-objects {
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 0;
  overflow: hidden;
}
.submenu-map-objects_opened {
  max-height: 1000px;
  padding-top: 7px;
}

.submenu-map-objects-text {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: var(--grey-3-color);
  margin-left: 4px;
  flex-grow: 1;
}

.submenu-piplenes {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 8px;
  flex-grow: 1;
}

.firewall-icon_disabled {
  opacity: 0.5;
}
</style>
